export { slider } from './Slider.mixins';
